import styles from "../styles/home.module.scss";
import { Background } from "../assets/index";
import { useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";
import $ from 'jquery';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faGithub, faTwitter, faFacebook } from "@fortawesome/free-brands-svg-icons";
import NavBar from "../components/NavBar";
import Installation from "../components/Installation";
import Features from "../components/Features";
import Projects from "../components/Projects";
import Support from "../components/Support";



const Landing = () => {
    const navigate = useNavigate();

    const handleExplore = () =>{
        navigate('/Installation');
    }


    (function () {
        let words=[" Build Swiftly"," configure the web"," Push with ease"],
                   i=0;
                   setInterval(function (){
                     $("#words").fadeOut(function(){
                       $(this).html(words[(i=(i+1) % words.length)]).fadeIn();
                     });
                   },5000);
      })();
    
      useEffect(() => {
        AOS.init();
        AOS.refresh();
      }, []);
    return ( 
    <div className={styles["container"]}>
        <NavBar />
    <div className={styles["Home-container"]}>
        <div className={styles["Home-flex"]}>
            <div className={styles["First-flex"]}>
                <div className={styles["Title"]}>Build Fast 
                <span className={styles["special"]} id="words" data-aos="fade-up-right "> Build Swiftly</span> </div>
                <div className={styles["text"]}>scaffold your projects with extra configurations</div>
                <div className={styles["button-container"]}>
                    <button className={styles["button"]} onClick={handleExplore}>Let's Explore</button>
                    <a href="https://github.com/DeveloperAspire/swifty-config">
                        <button className={styles["buttonf"]}>Github</button>
                    </a>
                </div>
            </div>
            <div className={styles["second-flex"]}>
            <img src={Background} alt="logo" className={styles["Header-logo"]}/>
            </div>
        </div>
        <div>
            <Installation />
        </div>
        <div>
            <Features />
        </div>
        <div>
            <Projects />
        </div>
        <div>
            <Support />
        </div>
        <footer>
        <p>
            Created by Swifty-config Team
        </p>
         <div className={styles["social-icons"]}>
                <a href="https://www.instagram.com/elimihelegods">
                <FontAwesomeIcon icon={faPhone} className={styles["icon"]}></FontAwesomeIcon>
                </a>
                <a href="twitter.com/Phantom1245">
                <FontAwesomeIcon icon={faTwitter} className={styles["icon"]}></FontAwesomeIcon>
                </a>
                <a href="https://www.facebook.com/profile.php?id=100076488365920">
                <FontAwesomeIcon icon={faFacebook} className={styles["icon"]}></FontAwesomeIcon>
                </a>

                <a href="https://github.com/DeveloperAspire/swifty-config">
                <FontAwesomeIcon icon={faGithub} className={styles["icon"]}></FontAwesomeIcon>
                </a>
            </div>
 
            <div className={styles["country"]}>&copy; Swifty-config 2022</div>
        </footer>

    </div>
    </div>
     );
}
 
export default Landing;
